<div class="card card-custom gutter-b card-strech">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" title="Pet Visit List" [ngClass]="{ 'active': procedures }" data-toggle="tab"
                        href="#pills-procedures" (click)="ver('procedures')">
                        <span class="nav-text">
                            PVL
                        </span>
                    </a>

                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': estimate }" id="pills-estimate-tab" data-toggle="tab"
                        data-bs-target="#pills-physical" href="#pills-estimate" (click)="ver('estimate')">
                        Estimate
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': prescriptions }" id="pills-prescriptions-tab"
                        data-toggle="tab" data-bs-target="#pills-prescriptions" href="#pills-prescriptions"
                        (click)="ver('prescriptions')">
                        Prescriptions
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': info }" data-toggle="tab" href="#pills-info"
                        (click)="ver('info')">
                        <span class="nav-text">
                            History
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': physical }" id="pills-physical-tab" data-toggle="tab"
                        data-bs-target="#pills-physical" href="#pills-physical" (click)="ver('physical')">
                        Suggestions
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': treatments }" id="pills-treatments-tab" data-toggle="tab"
                        data-bs-target="#pills-treatments" href="#pills-treatments" (click)="ver('treatments')">
                        Treatments
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': notes }" id="pills-notes-tab" data-toggle="tab"
                        data-bs-target="#pills-notes" href="#pills-notes" (click)="ver('notes')">
                        Notes
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': recalls }" id="pills-recalls-tab" data-toggle="tab"
                        data-bs-target="#pills-recalls" href="#pills-recalls" (click)="ver('recalls')">
                        Recall
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': check_in }" id="pills-check-in-tab" data-toggle="tab"
                        data-bs-target="#pills-check-in" href="#pills-check-in" (click)="ver('check_in')">
                        Check-in
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': metrics }" id="pills-metrics-tab" data-toggle="tab"
                        data-bs-target="#pills-metrics" href="#pills-metrics" (click)="ver('metrics')">
                        Metrics
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': appt_referred }" id="pills-appt_referred-tab"
                        data-toggle="tab" data-bs-target="#pills-appt_referred" href="#pills-appt_referred"
                        (click)="ver('appt_referred')">
                        Appointments
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': vitalsign }" data-toggle="tab" href="#pills-vitalsign"
                        (click)="ver('vitalsign')">
                        <span class="nav-text">
                            Vitals
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="tab-content">
        <div class="tab-pane fade" [ngClass]="{ 'show active': procedures }" id="pills-procedures" role="tabpanel"
            aria-labelledby="pills-procedures-tab">
            <ngx-work-procedures [pet_no]="pet_no"></ngx-work-procedures>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': vitalsign }" id="pills-vitalsign" role="tabpanel"
            aria-labelledby="pills-vital-tab">
            <ng-container *ngIf="vitalsign_loaded">
                <ngx-profile-proc [pet_no]="pet_no"></ngx-profile-proc>
            </ng-container>
            <div *ngIf="!vitalsign_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': recalls }" id="pills-recall" role="tabpanel"
            aria-labelledby="pills-recall-tab">
            <ng-container *ngIf="recalls_loaded">
                <ngx-work-recall [pet_no]="pet_no"></ngx-work-recall>
            </ng-container>
            <div *ngIf="!recalls_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': notes }" id="pills-notes" role="tabpanel"
            aria-labelledby="pills-notes-tab">
            <ng-container *ngIf="notes_loaded">
                <ngx-work-notes [pet_no]="pet_no" [client_no]="client_no"></ngx-work-notes>
            </ng-container>
            <div *ngIf="!notes_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': check_in }" id="pills-check-in" role="tabpanel"
            aria-labelledby="pills-check-in-tab">
            <ng-container *ngIf="check_in_loaded">
                <ngx-work-checkin [pet_no]="pet_no"></ngx-work-checkin>
            </ng-container>
            <div *ngIf="!check_in_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': metrics }" id="pills-metrics" role="tabpanel"
            aria-labelledby="pills-metrics-tab">
            <ng-container *ngIf="metrics_loaded">
                <ngx-work-pet-physical [pet_no]="pet_no"></ngx-work-pet-physical>
            </ng-container>
            <div *ngIf="!metrics_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': estimate }" id="pills-estimate" role="tabpanel"
            aria-labelledby="pills-estimate-tab">
            <ng-container *ngIf="estimate_loaded">
                <!-- <ngx-work-estimates></ngx-work-estimates> -->
                <ngx-estimate-page [pet_no]="pet_no" (onTransferToPVL)="transferToPVL($event)"></ngx-estimate-page>
            </ng-container>
            <div *ngIf="!estimate_loaded" class="p-4 text-muted">
                Open the Estimate tab to load data.
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': appt_referred }" id="pills-appt-referred" role="tabpanel"
            aria-labelledby="pills-appt-referred-tab">
            <ng-container *ngIf="appt_referred_loaded">
                <ngx-work-appt-referred [pet_no]="pet_no" [client_no]="client_no"></ngx-work-appt-referred>
            </ng-container>
            <div *ngIf="!appt_referred_loaded" class="p-4 text-muted">
                Open the Appointments tab to load data.
            </div>
        </div>

        <div class="tab-pane fade" [ngClass]="{ 'show active': prescriptions }" id="pills-prescriptions" role="tabpanel"
            aria-labelledby="pills-prescriptions-tab">

            <div class="card-body mt-0 pt-4" *ngIf="filtering_presc && prescriptions_loaded">

                <span *ngIf="petService.pet_prescriptions_filter.length === 0">No information available</span>
                <div class="table-responsive" style="height: 40vh;"
                    *ngIf="petService.pet_prescriptions_filter.length > 0">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th style="width: 50px;">
                                </th>
                                <th>
                                    Date Done
                                    <i *ngIf="petService.prescription_order === 1"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 2"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Product Name
                                    <i *ngIf="petService.prescription_order === 3"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 4"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Doctor
                                </th>
                                <th>
                                    Units
                                </th>
                                <th>
                                    #Rfl
                                </th>
                                <th>
                                    Rfl Exp
                                </th>
                                <th>
                                    Instructions
                                </th>
                                <th>
                                    Subst.
                                </th>
                                <th style="width: 10%;">
                                    Status
                                    <i *ngIf="petService.prescription_order === 5"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 6"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of petService.pet_prescriptions_filter | prescription:selectedTreeList | orderhistory:petService.prescription_order"
                                (click)="selectPresc(item)" [ngClass]="{'table-active': selectedPrescription === item}">
                                <td class="text-center">
                                    <i class="fas fa-edit text-primary" style="cursor: pointer;"
                                        (click)="updatePresc(item); $event.stopPropagation();"></i>
                                </td>
                                <td>
                                    {{ item.drug_note_date }}
                                </td>
                                <td>
                                    {{ item.product_name | uppercase }}
                                </td>
                                <td>
                                    {{ item.employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.units }}
                                </td>
                                <td>
                                    {{ item.refill_count }}
                                </td>
                                <td>
                                    {{ item.refill_expire }}
                                </td>
                                <td>
                                    {{ item.instructions }}
                                </td>
                                <td>
                                    {{ item.allow_generic === "True" ? 'YES' : 'NO' }}
                                </td>
                                <td>
                                    {{ item.in_clinic === 'True' ? 'Disp.' : 'Writ.' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <div class="card-body mt-0 pt-4" *ngIf="!filtering_presc && prescriptions_loaded">
                <span *ngIf="petService.pet_prescriptions.length === 0">No information available</span>
                <div class="table-responsive" style="height: 40vh;" *ngIf="petService.pet_prescriptions.length > 0">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th style="width: 50px;">
                                </th>
                                <th>
                                    Date Done
                                    <i *ngIf="petService.prescription_order === 1"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 2"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Product Name
                                    <i *ngIf="petService.prescription_order === 3"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 4"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Doctor
                                </th>
                                <th>
                                    Units
                                </th>
                                <th>
                                    #Rfl
                                </th>
                                <th>
                                    Rfl Exp
                                </th>
                                <th>
                                    Instructions
                                </th>
                                <th>
                                    Subst.
                                </th>
                                <th style="width: 10%;">
                                    Status
                                    <i *ngIf="petService.prescription_order === 5"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 6"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of petService.pet_prescriptions | prescription:selectedTreeList | orderhistory:petService.prescription_order"
                                (click)="selectPresc(item)" [ngClass]="{'table-active': selectedPrescription === item}">
                                <td class="text-center">
                                    <i class="fas fa-edit text-primary" style="cursor: pointer;"
                                        (click)="updatePresc(item); $event.stopPropagation();"></i>
                                </td>
                                <td>
                                    {{ item.drug_note_date }}
                                </td>
                                <td>
                                    {{ item.product_name | uppercase }}
                                </td>
                                <td>
                                    {{ item.employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.units }}
                                </td>
                                <td>
                                    {{ item.refill_count }}
                                </td>
                                <td>
                                    {{ item.refill_expire }}
                                </td>
                                <td>
                                    {{ item.instructions }}
                                </td>
                                <td>
                                    {{ item.allow_generic === "True" ? 'YES' : 'NO' }}
                                </td>
                                <td>
                                    {{ item.in_clinic === 'True' ? 'Disp.' : 'Writ.' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="card-footer text-right py-4"
                *ngIf="prescriptions_loaded && petService.pet_prescriptions.length > 0">
                <div class="text-left mb-2" *ngIf="selectedPrescription">
                    <small class="text-info">
                        <i class="fas fa-check-circle"></i>
                        Selected: {{ selectedPrescription.product_name }} ({{ selectedPrescription.drug_note_date }})
                    </small>
                </div>

                <div class="dropdown" style="position: absolute !important;">
                    <button class="btn btn-sm btn-info mr-2 font-weight-bold dropdown-toggle" type="button"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-sort-alpha-down icon-sm"></i>
                        Sort
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="presOrder(1)">ASC Date Done</a>
                        <a class="dropdown-item" (click)="presOrder(2)">DESC Date Done</a>
                        <a class="dropdown-item" (click)="presOrder(3)">ASC Product Name</a>
                        <a class="dropdown-item" (click)="presOrder(4)">DESC Product Name</a>
                        <a class="dropdown-item" (click)="presOrder(5)">ASC Status</a>
                        <a class="dropdown-item" (click)="presOrder(6)">DESC Status</a>
                    </div>
                </div>

                <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold"
                    (click)="filter(3, tree.treeModel)">
                    <i class="fas fa-filter icon-sm"></i>
                    Filter
                </button>

                <button type="button" class="btn btn-sm btn-primary" (click)="printPrescription()">
                    Print
                </button>
            </div>

            <div *ngIf="!prescriptions_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': info }" id="pills-info" role="tabpanel"
            aria-labelledby="pills-info-tab">

            <div class="card-body mt-0 pt-4" *ngIf="filtering && info_loaded">
                <span *ngIf="petService.pet_histories_filter.length === 0">No information available</span>
                <div class="search-results" *ngIf="petService.pet_histories_filter.length > 0">
                    <div class="max-h-500px" [class.table-responsive]="show_detail">
                        <table class="table table-bordered  table-sm rounded" [class.text-nowrap]="show_detail">
                            <thead class="thead-light">
                                <tr>
                                    <th>
                                        Description..
                                        <i *ngIf="petService.histories_order === 5"
                                            class="fas fa-sort-amount-down-alt icon-sm"></i>
                                        <i *ngIf="petService.histories_order === 6"
                                            class="fas fa-sort-amount-down icon-sm"></i>
                                    </th>
                                    <th>
                                        Date Done
                                        <i *ngIf="petService.histories_order === 1"
                                            class="fas fa-sort-amount-down-alt icon-sm"></i>
                                        <i *ngIf="petService.histories_order === 2"
                                            class="fas fa-sort-amount-down icon-sm"></i>
                                    </th>
                                    <th>
                                        Date Inv
                                        <i *ngIf="petService.histories_order === 3"
                                            class="fas fa-sort-amount-down-alt icon-sm"></i>
                                        <i *ngIf="petService.histories_order === 4"
                                            class="fas fa-sort-amount-down icon-sm"></i>
                                    </th>
                                    <th>
                                        Response
                                    </th>
                                    <th class="text-center">
                                        Requested By
                                    </th>
                                    <th class="text-center">
                                        Invoiced By
                                    </th>
                                    <th class="text-center">
                                        Unit
                                    </th>
                                    <th class="text-right" *ngIf="show_detail">
                                        Price
                                    </th>
                                    <th *ngIf="show_detail">
                                        Route
                                    </th>
                                    <th class="text-center" *ngIf="show_detail">
                                        Admin Loc
                                    </th>
                                    <th *ngIf="show_detail">
                                        Clinic
                                    </th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of petService.pet_histories_filter; let i = index">
                                <tr [ngStyle]="{'background-color': i % 2 === 0 ? '#EBEDF3' : '' }">
                                    <td>
                                        {{ item.procedure_desc }}
                                    </td>
                                    <td>
                                        {{ item.done_date }}
                                    </td>
                                    <td>
                                        {{ item.inv_date }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.response1 }}/{{ item.response2 }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.req_employee_initial | uppercase }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.inv_employee_initial | uppercase }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.unit }}
                                    </td>
                                    <td class="text-right" *ngIf="show_detail">
                                        {{ item.cost | currency }}
                                    </td>
                                    <td class="text-center" *ngIf="show_detail">
                                        {{ item.location }}
                                    </td>
                                    <td *ngIf="show_detail">
                                        {{ item.route }}
                                    </td>
                                    <td *ngIf="show_detail">
                                        {{ item.clinic_abbrev }}
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="show_detail && (petService.pet_subhistories | subhistory:item.history_sequence).length > 0">
                                    <td></td>
                                    <td colspan="10">
                                        <table class="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Description
                                                    </th>
                                                    <th>
                                                        Unit
                                                    </th>
                                                    <th>
                                                        Method of Issue
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let subitem of petService.pet_subhistories | subhistory:item.history_sequence">
                                                    <td>
                                                        {{ subitem.procedure_desc }}
                                                    </td>
                                                    <td>
                                                        {{ subitem.unit }}
                                                    </td>
                                                    <td>
                                                        {{ subitem.method_of_issue }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card-body mt-0 pt-4" *ngIf="!filtering && info_loaded">

                <span *ngIf="petService.pet_histories.length === 0">No information available</span>
                <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                    (scrolled)="onScroll()" [scrollWindow]="false" *ngIf="petService.pet_histories.length > 0">
                    <div [class.table-responsive]="show_detail">
                    <table class="table table-bordered  table-sm rounded" [class.text-nowrap]="show_detail">
                        <thead>
                            <tr>
                                <th>
                                    Description
                                    <i *ngIf="petService.histories_order === 5"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.histories_order === 6"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Date Done
                                    <i *ngIf="petService.histories_order === 1"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.histories_order === 2"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Date Inv
                                    <i *ngIf="petService.histories_order === 3"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.histories_order === 4"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Response
                                </th>
                                <th>
                                    Requested By
                                </th>
                                <th>
                                    Invoiced By
                                </th>
                                <th>
                                    Unit
                                </th>
                                <th *ngIf="show_detail">
                                    Price
                                </th>
                                <th *ngIf="show_detail">
                                    Route
                                </th>
                                <th *ngIf="show_detail">
                                    Admin Location
                                </th>
                                <th *ngIf="show_detail">
                                    Clinic
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of petService.pet_histories; let i = index">
                            <tr [ngStyle]="{'background-color': i % 2 === 0 ? '#EBEDF3' : '' }">
                                <td>
                                    {{ item.procedure_desc }}
                                </td>
                                <td>
                                    {{ item.done_date }}
                                </td>
                                <td>
                                    {{ item.inv_date }}
                                </td>
                                <td>
                                    {{ item.response1 }}/{{ item.response2 }}
                                </td>
                                <td>
                                    {{ item.req_employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.inv_employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.unit }}
                                </td>
                                <td *ngIf="show_detail">
                                    {{ item.cost | currency }}
                                </td>
                                <td *ngIf="show_detail">
                                    {{ item.location }}
                                </td>
                                <td *ngIf="show_detail">
                                    {{ item.route }}
                                </td>
                                <td *ngIf="show_detail">
                                    {{ item.clinic_abbrev }}
                                </td>
                            </tr>
                            <tr
                                *ngIf="show_detail && (petService.pet_subhistories | subhistory:item.history_sequence).length > 0">
                                <td></td>
                                <td colspan="10">
                                    <table class="table table-sm table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Description
                                                </th>
                                                <th>
                                                    Unit
                                                </th>
                                                <th>
                                                    Method of Issue
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let subitem of petService.pet_subhistories | subhistory:item.history_sequence">
                                                <td>
                                                    {{ subitem.procedure_desc }}
                                                </td>
                                                <td>
                                                    {{ subitem.unit }}
                                                </td>
                                                <td>
                                                    {{ subitem.method_of_issue }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>

            </div>
            <div class="card-footer text-right py-5" *ngIf="info_loaded && petService.pet_histories.length > 0">

                <div class="dropdown" style="position: absolute !important;">
                    <button class="btn btn-sm btn-info mr-2 font-weight-bold dropdown-toggle" type="button"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-sort-alpha-down icon-sm"></i>
                        Sort
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="order(1)">ASC Date Done</a>
                        <a class="dropdown-item" (click)="order(2)">DESC Date Done</a>
                        <a class="dropdown-item" (click)="order(3)">ASC Date Inv</a>
                        <a class="dropdown-item" (click)="order(4)">DESC Date Inv</a>
                        <a class="dropdown-item" (click)="order(5)">ASC Description</a>
                        <a class="dropdown-item" (click)="order(6)">DESC Description</a>
                    </div>
                </div>

                <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold"
                    (click)="filter(1, tree.treeModel)">
                    <i class="fas fa-filter icon-sm"></i>
                    Filter
                </button>

                <button type="button" class="btn btn-sm mr-2 font-weight-bold"
                    [ngClass]="show_detail ? 'btn-info' : 'btn-secondary'" (click)="show_detail = !show_detail">
                    <i *ngIf="!show_detail" class="fas fa-eye icon-sm"></i>
                    <i *ngIf="show_detail" class="fas fa-eye-slash icon-sm"></i>
                    {{ show_detail ? 'Detailed View' : 'Brief View' }}
                </button>

                <button type="button" class="btn btn-sm btn-primary" (click)="openPrintHistoryModal()">
                    Print
                </button>
            </div>

            <div *ngIf="!info_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': physical }" id="pills-physical" role="tabpanel"
            aria-labelledby="pills-physical-tab">

            <div class="card-body mt-0 pt-4" *ngIf="physical_loaded">


                <div class="table-responsive" style="height: 40vh;" *ngIf="petService.pet_suggestions.length > 0">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Date Suggested
                                </th>
                                <th>
                                    What was Suggested
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="petService.pet_suggestions.length === 0">
                                <td colspan="2">No information available</td>
                            </tr>
                            <tr *ngFor="let item of petService.pet_suggestions">
                                <td>
                                    {{ item.suggest_date }}
                                </td>
                                <td>
                                    {{ item.procedure_desc }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="card-footer text-right py-4" *ngIf="physical_loaded && petService.pet_suggestions.length > 0">

                <button type="button" class="btn btn-primary" (click)="printSuggestions()">
                    Print
                </button>
            </div>

            <div *ngIf="!physical_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': treatments }" id="pills-treatments" role="tabpanel"
            aria-labelledby="pills-treatments-tab">
            <ng-container *ngIf="treatments_loaded">
                <ngx-work-treatment-plan [pet_no]="pet_no"></ngx-work-treatment-plan>
            </ng-container>
            <div *ngIf="!treatments_loaded" class="p-4 text-muted">
                Open this tab to load data.
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalFilterHistory" tabindex="-1" role="dialog" aria-labelledby="modalFilterHistoryLabel"
    aria-hidden="true" (hidden.bs.modal)="onModalClose()">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <form (ngSubmit)="apply(tree.treeModel)" #formFilter="ngForm">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNewPetNoteLabel">Filter</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="onModalClose()">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">

                    <div class="search-filter">
                        <div class="row" *ngIf="id_filter !== 3">
                            <div class="col">
                                <div class="form-group">
                                    <label>Code:</label>
                                    <select class="form-control" id="selectedTreeList1" name="_code" [(ngModel)]="code">
                                        <option value=""></option>
                                        <option *ngFor="let item of selectedTreeList1" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Category:</label>
                                    <select class="form-control" id="selectedTreeList2" name="_category"
                                        [(ngModel)]="category" (change)="chgCategory()">
                                        <option value=""></option>
                                        <option *ngFor="let item of selectedTreeList2" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col" *ngIf="selectedTreeList3 && selectedTreeList3.length > 0">
                                <div class="form-group">
                                    <label>Subcategory:</label>
                                    <select class="form-control" id="selectedTreeList3" name="_subcategory"
                                        [(ngModel)]="subcategory">
                                        <option value=""></option>
                                        <option *ngFor="let item of selectedTreeList3" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{ id_filter === 3 ? 'Instruccions' : 'Description' }}:</label>
                                    <input type="text" class="form-control" name="_description"
                                        [(ngModel)]="description" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Select Items:</label>
                                    <div class="tree-container"
                                        style="max-height: 300px; overflow-y: auto; border: 1px solid #e1e5e9; padding: 10px; border-radius: 4px;">
                                        <tree-root #tree [nodes]="nodes" [options]="options">

                                            <ng-template #treeNodeFullTemplate let-node let-index="index"
                                                let-templates="templates">
                                                <div class="tree-node">

                                                    <input type="checkbox" [checked]="node.isActive"
                                                        (change)="node.toggleActivated(true)" />

                                                    <tree-node-expander [node]="node"></tree-node-expander>

                                                    <div class="node-content-wrapper"
                                                        [class.node-content-wrapper-active]="node.isActive"
                                                        [class.node-content-wrapper-focused]="node.isFocused"
                                                        (click)="node.toggleActivated(true)">

                                                        <span [class]="node.data.className" [class.title]="true">
                                                            {{ node.data.name }}
                                                        </span>

                                                    </div>

                                                    <tree-node-children [node]="node"
                                                        [templates]="templates"></tree-node-children>
                                                </div>
                                            </ng-template>

                                        </tree-root>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn font-weight-bold btn-secondary mr-3"
                        (click)="clear(tree.treeModel)">
                        <i class="fas fa-times icon-sm"></i>
                        Clear All
                    </button>
                    <button type="submit" class="btn font-weight-bold btn-primary">
                        <i class="fas fa-check icon-sm"></i>
                        Apply Filter
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Print Modal -->
<div class="modal fade" id="modalPrintHistory" tabindex="-1" role="dialog" aria-labelledby="modalPrintHistoryLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="modalPrintHistoryLabel">Print History</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form #printForm="ngForm">
                    <div class="form-group">
                        <label for="printType">Report Type:</label>
                        <select class="form-control" id="printType" name="printType"
                            [(ngModel)]="printOptions.printType" required>
                            <option value="historyOnly">Print History Only</option>
                            <option value="historyWithNotes">Print History with Notes</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="beginDate">Begin Date:</label>
                        <input type="date" class="form-control" id="beginDate" name="beginDate"
                            [(ngModel)]="printOptions.beginDate" required>
                    </div>

                    <div class="form-group">
                        <label for="endDate">End Date:</label>
                        <input type="date" class="form-control" id="endDate" name="endDate"
                            [(ngModel)]="printOptions.endDate" required>
                    </div>

                    <div class="form-group">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="printPrescriptionLog"
                                name="printPrescriptionLog" [(ngModel)]="printOptions.printPrescriptionLog">
                            <label class="form-check-label" for="printPrescriptionLog">
                                Print Prescription Log?
                            </label>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="printHistory()"
                    [disabled]="!printForm.valid">Print</button>
            </div>
        </div>
    </div>
</div>